import React from 'react';
import { string } from 'prop-types';

const IconTruck = props => {
  const { className } = props;

  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.99997 6H20C20.2194 6 20.4223 6.07065 20.5871 6.19045L30 12.8608V23L27.3736 23C27.2013 23.6699 26.8529 24.3039 26.3284 24.8284C24.7663 26.3905 22.2336 26.3905 20.6715 24.8284C20.147 24.3039 19.7986 23.6699 19.6263 23L12.3736 23C12.2013 23.6699 11.8529 24.3039 11.3284 24.8284C9.7663 26.3905 7.23364 26.3905 5.67154 24.8284C5.147 24.3039 4.7986 23.6699 4.62633 23L1.99997 23V6ZM21 18.8771C22.5706 17.6166 24.8716 17.7147 26.3284 19.1716C26.8529 19.6961 27.2013 20.3301 27.3736 21H28V13.8948L21 8.93426V18.8771ZM19 21H12.3736C12.2013 20.3301 11.8529 19.6961 11.3284 19.1716C9.7663 17.6095 7.23364 17.6095 5.67154 19.1716C5.147 19.6961 4.7986 20.3301 4.62633 21H3.99997V8H19V21ZM9.91418 20.5858C9.13313 19.8047 7.8668 19.8047 7.08576 20.5858C6.30471 21.3668 6.30471 22.6332 7.08576 23.4142C7.8668 24.1953 9.13313 24.1953 9.91418 23.4142C10.6952 22.6332 10.6952 21.3668 9.91418 20.5858ZM22.0858 20.5858C22.8668 19.8047 24.1331 19.8047 24.9142 20.5858C25.6952 21.3668 25.6952 22.6332 24.9142 23.4142C24.1331 24.1953 22.8668 24.1953 22.0858 23.4142C21.3047 22.6332 21.3047 21.3668 22.0858 20.5858Z"
        fill="black"
      />
    </svg>
  );
};

IconTruck.defaultProps = { className: null };

IconTruck.propTypes = {
  className: string,
};

export default IconTruck;
